'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialWhatsapp = function IoSocialWhatsapp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.8 2.5c9.5 0 17.2 7.6 17.2 17s-7.7 17.1-17.2 17.1c-3 0-5.8-0.8-8.3-2.1l-9.5 3 3.1-9.1c-1.5-2.6-2.5-5.7-2.5-8.9 0-9.4 7.8-17 17.2-17z m8.5 23.5c0.4-1 0.5-1.9 0.4-2s-0.4-0.3-0.8-0.6-2.5-1.4-2.9-1.5-0.7-0.2-1 0.2-1.3 1.3-1.5 1.6-0.5 0.4-1 0.1-1.8-0.8-3.4-2.3c-1.3-1.2-2.1-2.6-2.4-3.1s0-0.7 0.3-0.9c0.2-0.2 0.5-0.5 0.7-0.7s0.3-0.4 0.5-0.7 0-0.6 0-0.8-1-2.4-1.3-3.3-0.8-0.8-1-0.8h-0.8s-0.8 0.1-1.2 0.5-1.6 1.5-1.7 3.6 1.4 4.2 1.7 4.5 2.8 5 7.2 6.9 4.5 1.3 5.3 1.3 2.5-1 2.9-2z' })
        )
    );
};

exports.default = IoSocialWhatsapp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-whatsapp.js
// module id = 2485
// module chunks = 0